/* eslint-disable */
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { Bell, Check } from "lucide-react";

export default function NotificationBell() {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const ref = useRef(null);

  const timeAgo = (iso) => {
    const d = new Date(iso);
    const s = Math.floor((Date.now() - d.getTime()) / 1000);
    if (s < 60) return t("notifications.now");
    if (s < 3600) return t("notifications.minAgo", { count: Math.floor(s / 60) });
    if (s < 86400) return t("notifications.hourAgo", { count: Math.floor(s / 3600) });
    return d.toLocaleDateString(i18n.language);
  };

  const load = async () => {
    try {
      const r = await api.get("/notifications");
      setItems(r.data.notifications);
      setUnread(r.data.unread);
    } catch {}
  };

  useEffect(() => {
    load();
    const tmr = setInterval(load, 60000);
    return () => clearInterval(tmr);
  }, []);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };
  const markOne = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  return (
    <div className="relative" ref={ref}>
      <button onClick={() => { setOpen((o) => !o); if (!open) load(); }} className="relative p-2 text-[#E2E8F0] hover:text-[#00BFFF] transition-colors" data-testid="notification-bell" aria-label={t("notifications.aria")}>
        <Bell size={20} />
        {unread > 0 && (
          <span className="absolute top-0.5 right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-[#EF4444] text-white text-[10px] font-bold flex items-center justify-center" data-testid="notification-count">
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 max-w-[90vw] card-flat z-50 shadow-2xl" data-testid="notification-dropdown">
          <div className="flex items-center justify-between p-3 border-b border-[#1E293B]">
            <span className="font-display font-bold text-sm">{t("notifications.title")}</span>
            {unread > 0 && <button onClick={markAll} className="text-xs text-[#00BFFF] hover:underline flex items-center gap-1" data-testid="mark-all-read"><Check size={13} /> {t("notifications.markAll")}</button>}
          </div>
          <div className="max-h-80 overflow-y-auto">
            {items.length === 0 ? (
              <div className="p-6 text-center text-sm text-[#94A3B8]" data-testid="notif-empty">{t("notifications.empty")}</div>
            ) : items.map((n) => (
              <button key={n.id} onClick={() => markOne(n.id)} className={`w-full text-left p-3 border-b border-[#1E293B]/60 hover:bg-[#111C30] transition-colors flex gap-3 ${n.read ? "opacity-60" : ""}`} data-testid={`notif-${n.id}`}>
                <span className={`mt-1.5 w-2 h-2 rounded-full shrink-0 ${n.read ? "bg-[#3A4A63]" : "bg-[#00BFFF]"}`} />
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-[#E2E8F0] truncate">{n.title}</div>
                  <div className="text-xs text-[#94A3B8]">{n.body}</div>
                  <div className="text-[10px] text-[#5B6B82] mt-0.5">{timeAgo(n.created_at)}</div>
                </div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
